<template>
    <settings-editor-base
        v-bind:label="label"
    >
        <template>
            <div class="position-picker-positions">
                <div v-for="position in positions"
                    :key="position.key"
                    class="position"
                    data-toggle="tooltip"
                    v-bind:class="position.classes"
                    v-bind:title="position.tooltip"
                    @click="$emit('input', position.key)"
                ></div>
            </div>
        </template>
    </settings-editor-base>
</template>

<script>
    import {autoInitializeTooltips as autoInitializeTooltipsMixin} from "../../../../Util/Mixins/tooltips";
    import {    
        settingsPositionTopLeftTooltip,
        settingsPositionTopCenterTooltip,
        settingsPositionTopRightTooltip,
        
        settingsPositionMiddleLeftTooltip,
        settingsPositionMiddleCenterTooltip,
        settingsPositionMiddleRightTooltip,
        
        settingsPositionBottomLeftTooltip,
        settingsPositionBottomCenterTooltip,
        settingsPositionBottomRightTooltip
    } from "../../tooltips";

    import positions from '../../CustomStylingOptions/positions'
    import SettingsEditorBase from "./SettingsEditorBase.vue";
    
    const positionSettings = {
        topLeft: { classes: 'top left', tooltip: settingsPositionTopLeftTooltip },
        top: {classes: 'top center', tooltip: settingsPositionTopCenterTooltip},
        topRight: {classes: 'right top', tooltip: settingsPositionTopRightTooltip},

        left: {classes: 'middle left', tooltip: settingsPositionMiddleLeftTooltip},
        center: {classes: 'middle center', tooltip: settingsPositionMiddleCenterTooltip},
        right: {classes: 'middle right', tooltip: settingsPositionMiddleRightTooltip},
        
        bottomLeft: {classes: 'bottom left', tooltip: settingsPositionBottomLeftTooltip},
        bottom: {classes: 'bottom center', tooltip: settingsPositionBottomCenterTooltip},
        bottomRight: {classes: 'bottom right', tooltip: settingsPositionBottomRightTooltip}
    };
    
    const validator = (value) => {
        //Check whether our value is a valid location
        return value && Object.keys(positions).indexOf(value) !== -1;
    };
    
    export default {
        name: "settings-positioning",
        components: {SettingsEditorBase},
        mixins: [autoInitializeTooltipsMixin],
        computed: {
            positions: () => {
                return Object.keys(positions).map(position => {
                    const settings = positionSettings[position];
                    
                    return {
                        key: position,
                        classes: settings.classes,
                        tooltip: settings.tooltip
                    }
                });
            }
        },
        props: {
            label: {
                type: String,
                required: true
            },
            value: {
                type: String,
                required: true,
                validate: validator
            }
        }
    };
</script>

<style scoped lang="scss" src="../../Style/settings-position.scss">
</style>
